import React from 'react';
import PropTypes from 'prop-types';
import { useTheme } from 'react-jss';
import useStyles from './styles';
import clsx from 'clsx';
import { Typography } from '../Typography';
const Option = ({ option, onSelectOption, tag: Tag = 'li', active = false, customClassName = '', customActiveClassName = '', inlineStyles = {}, typographyProps = {} }) => {
    const theme = useTheme();
    const classes = useStyles({ theme });
    const { label, handler } = option;
    const containerStyle = clsx({
        [classes.container]: true,
        [classes.active]: active,
        [customClassName]: Boolean(customClassName),
        [customActiveClassName]: active && Boolean(customActiveClassName)
    });
    const onClick = () => {
        if (typeof handler === 'function')
            handler(option);
        onSelectOption(option);
    };
    const composedTypographyProps = Object.assign({ variant: 'content2', inheritColor: true }, typographyProps);
    return (React.createElement(Tag, { className: containerStyle, onClick: onClick, style: inlineStyles },
        React.createElement(Typography, Object.assign({}, composedTypographyProps), label)));
};
Option.propTypes = {
    option: PropTypes.object.isRequired,
    onSelectOption: PropTypes.func.isRequired,
    tag: PropTypes.string,
    active: PropTypes.bool,
    customClassName: PropTypes.string,
    customActiveClassName: PropTypes.string,
    inlineStyles: PropTypes.object,
    typographyProps: PropTypes.shape({
        children: PropTypes.node,
        variant: PropTypes.oneOf([
            'header1',
            'header2',
            'header3',
            'header4',
            'content1',
            'content2',
            'content3'
        ]),
        weight: PropTypes.oneOf([
            'light',
            'normal',
            'bold',
            'bolder'
        ]),
        italic: PropTypes.bool,
        link: PropTypes.bool,
        inheritColor: PropTypes.bool,
        customClassName: PropTypes.string
    })
};
export { Option };
//# sourceMappingURL=Option.js.map